import React, { useState, useEffect } from "react";
import { FaSearch, FaDownload, FaSignOutAlt, FaAngleDoubleLeft, FaAngleDoubleRight,FaChartBar } from "react-icons/fa";
import { BiSolidDashboard,BiAnalyse } from "react-icons/bi";
import { FaArrowTrendUp,FaMagnifyingGlassChart } from "react-icons/fa6";
import { TbReportSearch } from "react-icons/tb";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTES, STRINGS } from "../../comman/constants";

import "./sidebar.css";


const Sidebar = ({ sidebarOpen }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selectedItem, setSelectedItem] = useState(localStorage.getItem("route")); // Track selected item

  const navigate = useNavigate();
  const location = useLocation();


  const toggleSidebar = (collapsed) => {
    setIsCollapsed(!collapsed);
    sidebarOpen(!collapsed);
  };

  const handleItemClick = (item) => {
    localStorage.setItem("route", item)
    setSelectedItem(item);
    navigate(`/${item}`)
  };

  function logout() {
    localStorage.clear();
    navigate(ROUTES.LOGIN);
  }

  // Sync selected item with the current route on mount and route changes
  useEffect(() => {
    const currentRoute = location.pathname.replace("/", "");
    setSelectedItem(currentRoute);
    localStorage.setItem("route", currentRoute)
  }, [location]);

  // useEffect(() => {
  //   localStorage.setItem("route", selectedItem)
  // }, [])

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        {!isCollapsed && <img className="myflexa-logo" src="/assets/icons/myFlexa_inverted.png" alt="Logo" />}
        <button onClick={() => toggleSidebar(isCollapsed)} className="toggle">
          {isCollapsed ? <FaAngleDoubleRight />
            : <FaAngleDoubleLeft />}

        </button>
      </div>
      <ul className="sidebar-list">
      {/* <li
          className={`sidebar-item ${localStorage.getItem("route") === ROUTES.SALES_DASHBOARD ? "selected" : ""}`}
          onClick={() => handleItemClick(ROUTES.SALES_DASHBOARD)}
        >
          <BiSolidDashboard className="sidebar-icon" />
          <span className={`sidebar-text ${isCollapsed ? "hidden" : ""}`}>{STRINGS.sidebar.sales_dashboard}</span>
        </li> */}
        <li
          className={`sidebar-item ${localStorage.getItem("route") === ROUTES.DASHBOARD ? "selected" : ""}`}
          onClick={() => handleItemClick(ROUTES.DASHBOARD)}
        >
          <BiSolidDashboard className="sidebar-icon" />
          <span className={`sidebar-text ${isCollapsed ? "hidden" : ""}`}>{STRINGS.sidebar.dashboard}</span>
        </li>
        <li
          className={`sidebar-item ${localStorage.getItem("route") === ROUTES.ONBOARDING_STATISTICS ? "selected" : ""}`}
          onClick={() => handleItemClick(ROUTES.ONBOARDING_STATISTICS)}
        >
          <FaChartBar className="sidebar-icon" />
          <span className={`sidebar-text ${isCollapsed ? "hidden" : ""}`}>{STRINGS.sidebar.onboardingStatistics}</span>
        </li>
        <li
          className={`sidebar-item ${localStorage.getItem("route") === ROUTES.MR_ANALYSIS ? "selected" : ""}`}
          onClick={() => handleItemClick(ROUTES.MR_ANALYSIS)}
        >
          <FaMagnifyingGlassChart className="sidebar-icon" />
          <span className={`sidebar-text ${isCollapsed ? "hidden" : ""}`}>{STRINGS.sidebar.mrAnalysis}</span>
        </li>
        <li
          className={`sidebar-item ${localStorage.getItem("route") === ROUTES.DOCTORRETENSION ? "selected" : ""}`}
          onClick={() => handleItemClick(ROUTES.DOCTORRETENSION)}
        >
          <FaSearch className="sidebar-icon" />
          <span className={`sidebar-text ${isCollapsed ? "hidden" : ""}`}>{STRINGS.sidebar.doctorRetention}</span>
        </li>
        <li
          className={`sidebar-item ${localStorage.getItem("route") === ROUTES.TRENDS ? "selected" : ""}`}
          onClick={() => handleItemClick(ROUTES.TRENDS)}
        >
          <FaArrowTrendUp className="sidebar-icon" />
          <span className={`sidebar-text ${isCollapsed ? "hidden" : ""}`}>{STRINGS.sidebar.trendsData}</span>
        </li>
        <li
          className={`sidebar-item ${localStorage.getItem("route") === ROUTES.DOWNLOADEXCEL ? "selected" : ""}`}
          onClick={() => handleItemClick(ROUTES.DOWNLOADEXCEL)}
        >
          <FaDownload className="sidebar-icon" />
          <span className={`sidebar-text ${isCollapsed ? "hidden" : ""}`}>{STRINGS.sidebar.downloadExcel}</span>
        </li>
        <li
          className={`sidebar-item ${localStorage.getItem("route") === ROUTES.REPORTS ? "selected" : ""}`}
          onClick={() => handleItemClick(ROUTES.REPORTS)}
        >
          <TbReportSearch className="sidebar-icon" />
          <span className={`sidebar-text ${isCollapsed ? "hidden" : ""}`}>{STRINGS.sidebar.report}</span>
        </li>
        <li

          className={`sidebar-item ${localStorage.getItem("route") === "logout" ? "selected" : ""}`}
          onClick={() => logout()}
        >
          <FaSignOutAlt className="sidebar-icon" />
          <span className={`sidebar-text ${isCollapsed ? "hidden" : ""}`}>{STRINGS.sidebar.logout}</span>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
